<ion-header>
  <ion-toolbar class="no-safe-area-top">
    <ion-title>{{ "modals.price_info.header" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<div class="summary">
  <ion-item-group class="summary-content">

    <ion-item
      class="summary-item ion-bg-white ion-padding-horizontal black-text-color"
      lines="1"
    >
      <ion-label class="fs-3 font600 ion-no-margin">{{
        "modals.price_info.total_price" | translate
      }}</ion-label>
      <ion-label class="fs-3 font600 ion-no-margin" slot="end">
        {{ priceInfo.origPrice | currency : priceInfo.currency }}
      </ion-label>
    </ion-item>

    <ion-item
      class="summary-item ion-bg-white ion-padding-horizontal desc-text-color"
      lines="1"
    >
      <ion-label class="fs-3 font600 ion-no-margin">{{
        "modals.price_info.discount" | translate
      }}</ion-label>
      <ion-label class="fs-3 font600 ion-no-margin" slot="end">
        -{{ priceInfo.discount | currency : priceInfo.currency }}
      </ion-label>
    </ion-item>
    
    <ion-item
      class="summary-item ion-bg-white ion-padding-horizontal black-text-color total-price"
      lines="none"
    >
      <ion-label class="fs-3 font600 ion-no-margin">{{
        "modals.price_info.amount_to_be_paid" | translate
      }}</ion-label>
      <ion-label class="fs-3 font600 ion-no-margin" slot="end">
        {{ priceInfo.finalPrice | currency : priceInfo.currency }}
      </ion-label>
    </ion-item>
  </ion-item-group>
</div>

<ion-footer class="padb5">
  <ion-toolbar class="pad5 ion-bg-white">
    <ion-button
      expand="block"
      class="primary-btn book-btn fs-3 font500"
      (click)="proceedForBooking()"
    >
      {{ "modals.price_info.book_now" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
